$("document").ready(function () {

	// --------------------- domluvit schuzku ------------------------------------
	$("#customformElement20").val($("#domluvit_prohlidku-form input[name='time']").val());

	$("#domluvit_prohlidku-form input").change(function () {
		if($(this).attr("name") == "time") {
		}

		if($(this).attr("name") == "kontakt") {
			$("#customformElement21").val($(this).val());
		}
	});

	if ($("#domluvit_prohlidku-form .customform .success").length) {
		$.nmManual("#domluvit_prohlidku-form .success", {
			sizes: {
				minW: 500
			}
		});
		$(".nyroModalCont").addClass("testRideModal");
	}

	// -------------- rezervace kola -------------------------

	$(".reserve").click(function (event) {
		event.preventDefault();

		$("#customformElement17").text(window.atob($(this).attr("info")));

		$.nmManual("#reservation-form", {
			sizes: {
				minW: 500
			}
		});
		$(".nyroModalCont").addClass("testRideModal");

	});

	if ($("#reservation-form .error li").length || $("#reservation-form .customform").hasClass("success")) {
		$.nmManual("#reservation-form", {
			sizes: {
				minW: 500
			}
		});
		$(".nyroModalCont").addClass("testRideModal");
	}
});